export default {
  sd_sub_status: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  sd_sub_status:[],
  selected_sd_sub_status : {},
  sd_sub_status_status:[]
}
